import { isUUID } from "utils/validators";

export const validateNodeId = (id: string | null, projectId: string) =>
  id !== projectId && isUUID(id) ? id : null;
